/** Shared row shaping for league table widgets. */

export function blockToFields(block, pointsFallback) {
  if (!block) return {};
  return {
    played: block.played,
    won: block.won,
    drawn: block.drawn,
    lost: block.lost,
    gd: block.gd,
    gf: block.gf,
    ga: block.ga,
    points: block.points ?? pointsFallback,
  };
}

export function normalizeTableRow(row, view = 'overall') {
  if (Array.isArray(row)) {
    return {
      position: row[0],
      team: row[1],
      points: row[2],
      played: null,
      won: null,
      drawn: null,
      lost: null,
      gd: null,
      gf: null,
      ga: null,
      form: '',
      zone: null,
      teamLogo: null,
      teamLogoProxy: null,
    };
  }

  const base = {
    position: row.position,
    team: row.team,
    teamLogo: row.teamLogo,
    teamLogoProxy: row.teamLogoProxy,
    points: row.points,
    played: row.played,
    won: row.won,
    drawn: row.drawn,
    lost: row.lost,
    gd: row.gd,
    gf: row.gf,
    ga: row.ga,
    form: row.form || '',
    zone: row.zone || null,
    zoneLabel: row.zoneLabel || null,
    home: row.home,
    away: row.away,
    overall: row.overall,
  };

  if (view === 'home' && row.home) return { ...base, ...blockToFields(row.home, base.points) };
  if (view === 'away' && row.away) return { ...base, ...blockToFields(row.away, base.points) };
  if (view === 'overall' && row.overall) {
    return { ...base, ...blockToFields(row.overall, base.points) };
  }
  return base;
}

export function rowHasHomeAway(rows) {
  const sample = rows.find((r) => r && !Array.isArray(r));
  return Boolean(sample?.home && sample?.away);
}

export function goalsDisplay(gf, ga) {
  if (gf == null && ga == null) return '—';
  return `${gf ?? 0}:${ga ?? 0}`;
}
